// src/components/invoices/DeleteDraftInvoiceDialog.tsx
import { Alert, Button, Dialog, Portal, Text } from '@chakra-ui/react'

interface DeleteDraftInvoiceDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => Promise<void> | void
  loading?: boolean
  error?: string | null
}

export function DeleteDraftInvoiceDialog({
  isOpen,
  onClose,
  onConfirm,
  loading,
  error,
}: DeleteDraftInvoiceDialogProps) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={details => {
        if (!details.open && !loading) onClose()
      }}
      size="md"
      closeOnInteractOutside={false}
      closeOnEscape={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Rechnungsvorschau löschen</Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text>
                Die Rechnungsvorschau ist noch keine ausgestellte Rechnung. Beim Löschen wird sie
                unwiderruflich entfernt.
              </Text>

              {error ? (
                <Alert.Root status="error">
                  <Alert.Indicator />
                  <Alert.Description>{error}</Alert.Description>
                </Alert.Root>
              ) : null}
            </Dialog.Body>

            <Dialog.Footer>
              <Button variant="outline" onClick={onClose} disabled={!!loading}>
                Abbrechen
              </Button>

              <Button colorPalette="red" loading={!!loading} onClick={onConfirm}>
                Löschen
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
